import { createSelector } from '@ngrx/store';

import { primaryInterestAdapter } from '../adapters/primary-interest.adapter';
import { selectPreferencesState } from './preferences.selectors';

export const selectPrimaryInterestsState = createSelector(
  selectPreferencesState,
  (preferencesState) => preferencesState.primaryInterests
);

export const selectPrimaryInterestsLoading = createSelector(
  selectPrimaryInterestsState,
  (preferencesState) => preferencesState.loading
);

export const selectCanLoadMorePrimaryInterests = createSelector(
  selectPrimaryInterestsState,
  (preferencesState) => preferencesState.nextPage
);

export const selectPrimaryInterestsInitialFilter = createSelector(
  selectPrimaryInterestsState,
  (preferencesState) => preferencesState.initialFilter
);

export const selectPrimaryInterests = createSelector(
  selectPrimaryInterestsState,
  primaryInterestAdapter.getSelectors().selectAll
);
